import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import logo from "../../assets/logo.png"; 

function Navbar({ isAuthenticated, setIsAuthenticated }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsAuthenticated(false);
      navigate('/login'); // Redirect after logout
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Link to="/" style={{ fontSize: '40px', textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
      <img 
        src={logo} // Replace with your image path or URL
        alt="Cinevest Logo"
        style={{ width: '40px', height: '40px', marginRight: '10px' }} // Adjust size and spacing
      />
     <span class="font-bold">Cinevest</span> 
    </Link>     
     <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        {isAuthenticated ? (
          <>
            <Link to="/profile" style={{ fontSize: '20px' }}>Profile</Link>
            <button 
              onClick={handleLogout}
              style={{ fontSize: '20px', background: 'none', border: 'none', cursor: 'pointer', color:'red' }}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" style={{ fontSize: '20px' }}>Login</Link>
            <Link to="/signup" style={{ fontSize: '20px' }}>Signup</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
